import { defineMessages } from 'react-intl';

export default defineMessages({
  showMore: {
    id: 'frontbucket.repository-details.modal.showMore',
    description: 'Action to show more items on the list',
    defaultMessage: 'Show more',
  },
});
